import 'babel/polyfill'
import '../assets/stylesheets/index.css'
import React from 'react'
import Root from './Root'

React.render(<Root />, document.getElementById('app'))



/** WEBPACK FOOTER **
 ** ./lib/index.js
 **/